import { CheckCircle2, XCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { CT } from "@/lib/connectionsTheme";

export const IntakeSettingsTab = ({ overview }) => (
  <div className="space-y-4" data-testid="intake-settings-tab">
    <div className={`${CT.panel} p-5`} data-testid="intake-settings-frontdesk-status">
      <p className={CT.cardTitle}>Destination Solution</p>
      <div className="mt-3 flex items-center gap-2.5">
        {overview?.front_desk_enabled ? (
          <>
            <CheckCircle2 size={16} className="text-emerald-600 dark:text-emerald-400" />
            <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">Front Desk is enabled — submissions can be routed here.</span>
          </>
        ) : (
          <>
            <XCircle size={16} className="text-red-600 dark:text-red-400" />
            <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
              Front Desk is not enabled for your organization. Ask a Platform Admin to enable it, or visit{" "}
              <Link to="/dashboard" className="text-blue-600 underline dark:text-blue-400">Solutions</Link>.
            </span>
          </>
        )}
      </div>
    </div>
    <p className={CT.textSecondary}>
      Identity verification (Email/SMS OTP) and QR branding settings will appear here as they're configured per Intake Model.
    </p>
  </div>
);
